import React from 'react';
import { Box, Grid } from '@material-ui/core';

/**
 * Composant d'en-tête de grille pour les groupes d'utilisateurs
 *
 * Ce composant affiche les en-têtes de colonnes pour la grille des groupes :
 * - Nom du groupe
 * - Identifiant
 * - Rôle
 * - Colonne d'actions
 *
 * Logique métier :
 * - Structure fixe des colonnes de la grille
 * - Alignement cohérent avec les éléments de grille
 * - Espacement approprié pour l'interface
 *
 * @returns Composant React d'en-tête de grille
 */
export function UserGroupGridHeader() {
  return (
    <Box mt={1} mb={1}>
      <Grid container spacing={1} justify={'space-between'}>
        <Grid item xs={3}>
          Nom
        </Grid>
        <Grid item xs={3}>
          Identifiant
        </Grid>
        <Grid item xs={3}>
          Rôle
        </Grid>
        <Grid item xs={1}>
          &nbsp;
        </Grid>
      </Grid>
    </Box>
  );
}
